import { render, staticRenderFns } from "./driver_manager_roster_list_help.vue?vue&type=template&id=12a0cb80&scoped=true&"
import script from "./driver_manager_roster_list_help.vue?vue&type=script&lang=js&"
export * from "./driver_manager_roster_list_help.vue?vue&type=script&lang=js&"
import style0 from "./driver_manager_roster_list_help.vue?vue&type=style&index=0&id=12a0cb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0cb80",
  null
  
)

export default component.exports